<template>
	<div class="copy-main-container" :class="{
			left: margin !== 'right',
			right: margin === 'right',
			button: button
		}">
		<input :class="{ 'copiar-text-copy': true, 'hideText': hideText }" type="text" readonly :value="text" ref="copy-this"/>
		<span title="Copiar" @click="copy()" :data-text-icon="iconText">
			<i class="far fa-copy"></i>
		</span>
		<!--<notification corner="bottom-right" :closed="true" />-->
	</div>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			default: null
		},
		margin: {
			type: String,
			default: null
		},
		hideText: {
			type: Boolean,
			default: false
		},
		button: {
			type: Boolean,
			default: false
		},
		iconText: {
			type: String,
			default: 'ID'
		}
	},
	methods: {
		copy () {
			const element = this.$refs['copy-this']
			element.select()
			document.execCommand('copy')
			window.notificationEM.open('', `Texto copiado: ${this.text}`, 'info')
		}
	}

}
</script>

<style lang="scss" scoped>
	.copy-main-container:not(.button) {
		display: flex;
		width: 100%;

		.copiar-text-copy {
			width: calc(100% - 18px);
			background-color: transparent;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			border: none;
			&:focus {
				border: none;
			}
		}
		cursor: pointer;
		&.left {
			margin-left: 5px;
		}
		&.right {
			margin-right: 5px;
		}
		span {
			height: 18px;
			width: 18px;
			border-radius: 18px;
			display: flex;
			align-items: center;
			justify-content: center;
			&:hover{
				i {
					color: orangered
				}
			}
		}

		// Gambiarra pra funcionar na gambiarra anterior
		.hideText {
			position: absolute;
			z-index: -1;
			opacity: 0;
			pointer-events: none;
		}

		.hideText ~ span {
			i {
				margin-left: 25px;
			}

			&::after{
				display: inline-block;
				content: 'Copiar';
				margin: 0 5px;
				font-size: .75em;
			}

			&:hover::after {
				color: #FF4500;
			}
		}
	}

	.copy-main-container.button {
		position: relative;
		overflow: hidden;
		input {
			position: fixed;
			z-index: -1;
			top: 0;
			left: 0;
			opacity: 0;
			pointer-events: none;
		}

		span {
			display: block;
			width: 100%;
			height: 100%;
			text-align: center;
			color: #FFF;
			background-color: $btn-color-green;
			&:hover {
				background-color: $btn-color-green-darker;
			}

			&::after {
				content: attr(data-text-icon);
				font-size: .8em;
				font-weight: bold;
			}

			i {
				display: none;
			}
		}

		/*
		<div class="copy-main-container" :class="{
			left: margin !== 'right',
			right: margin === 'right',
			button: button
		}">
		<input :class="{ 'copiar-text-copy': true, 'hideText': hideText }" type="text" readonly :value="text" ref="copy-this"/>
		<span title="Copiar" @click="copy()">
			<i class="far fa-copy"></i>
		</span>
		*/
	}
</style>
